/**
 * The occupation page's four sections, in order.
 *
 * 04-occupations section 1 and 2: explore the occupation, then the credential
 * that prepares you for it, then the school that teaches it. **The second and
 * third are a sequence, not a menu**, because a member who reaches schools
 * before understanding the credential is choosing between things they cannot
 * yet tell apart.
 *
 * That is why Readiness Assessment comes before Schools. It was the other way
 * round, which put the school list ahead of the argument for going to one.
 * A member can still jump; the order carries the argument for those who do not.
 */
export const OCCUPATION_SECTIONS: {
  label: string;
  /** MOBILE.1 G2. The label on a phone, where four full ones do not fit a row. */
  shortLabel: string;
  id:
    | 'career-overview'
    | 'career-insights'
    | 'schools-programs'
    | 'readiness-assessment';
}[] = [
  {
    label: 'Career Overview',
    shortLabel: 'Overview',
    id: 'career-overview'
  },
  {
    label: 'Career Insights',
    shortLabel: 'Insights',
    id: 'career-insights'
  },
  {
    label: 'Readiness Assessment',
    shortLabel: 'Readiness',
    id: 'readiness-assessment'
  },
  {
    label: 'Schools / Programs',
    shortLabel: 'Schools',
    id: 'schools-programs'
  }
];
